import { useWithLoadingState } from '@/hooks/useWithLoadingState';
import { cn } from '@/utils';
import { HeartIcon } from '@netfront/ui-library';
import React from 'react';
import { IconHourGlass } from '../Icons/IconHourGlass';

const BookmarkPill: React.FC<{
  isBookmarked: boolean;
  onBookmarkToggle: () => Promise<unknown>;
  className?: string;
}> = ({ isBookmarked, onBookmarkToggle, className }) => {
  const [toggleBookmark, isToggling] = useWithLoadingState(onBookmarkToggle);

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    await toggleBookmark();
  };

  const icon = React.useMemo(() => {
    const iconStyle = 'h-6 shadow rounded-full flex items-center mb-2';
    if (isToggling) {
      return <IconHourGlass />;
    }

    return (
      <HeartIcon
        className={cn(iconStyle, {
          'color-red-500': isBookmarked,
        })}
      />
    );
  }, [isToggling, isBookmarked]);

  return (
    <button className={cn('border-none p-0 pointer', className)} onClick={handleClick}>
      <label className="sr-only">Bookmark Exercise</label>
      {icon}
    </button>
  );
};

export default BookmarkPill;
